import { sendTracking } from '@helpers/tracking';

export function sendRemoveProductTracking(): void {
    sendTracking(false, {
        action: 'Clic_affichage',
        category: 'Comparaison_telephone',
        name: 'Supprimer_tel_comparaison',
    });
}

export function sendBackToPreviousPageTracking(): void {
    sendTracking(false, {
        action: 'Clic_affichage',
        category: 'Comparaison_telephone',
        name: 'Retour',
    });
}
